// extracted by mini-css-extract-plugin
export default {"mainWrap":"HelpCenterPage_mainWrap__04yvE cobe-globals_mainWrap__qu6Pq","container":"HelpCenterPage_container__KZTtL","pageTitle":"HelpCenterPage_pageTitle__vc7KG"};